import React from 'react'

import classes from './CircularProgress.module.scss'

interface CircularProgressProps {
  size?: number
  thickness?: number
  value?: number
  color?: string
}

export const CircularProgress: React.FC<CircularProgressProps> = ({
  size = 40,
  thickness = 3.6,
  value = 30,
  color
}) => {
  const radius = (size - thickness) / 2
  const circumference = 2 * Math.PI * radius
  const strokeDashoffset = circumference - (value / 100) * circumference

  return (
    <div className={classes.container} style={{ width: size, height: size }}>
      <svg className={classes.svg} viewBox={`0 0 ${size} ${size}`}>
        {/* Background circle */}
        <circle
          className={classes.circleBg}
          cx={size / 2}
          cy={size / 2}
          fill="none"
          r={radius}
          strokeWidth={thickness}
        />
        {/* Progress circle */}
        <circle
          className={classes.circle}
          cx={size / 2}
          cy={size / 2}
          fill="none"
          r={radius}
          stroke={color || `var(--concorde-primary-color)`}
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          strokeWidth={thickness}
        />
      </svg>
    </div>
  )
}
